import { render } from "./CooKie.vue?vue&type=template&id=f24e338a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CooKie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f24e338a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f24e338a', __exports__)) {
    api.reload('f24e338a', __exports__)
  }
  
  module.hot.accept("./CooKie.vue?vue&type=template&id=f24e338a", () => {
    api.rerender('f24e338a', render)
  })

}


export default __exports__